import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import StyledComponent from '~/components/Styled/Styled';
import { connect } from 'react-redux';
import logEvent from '~/util/analytics';
import Link from '~/components/Link/Link';
import classnames from 'classnames/bind';

import css from '~/components/EventsDropdown/EventsDropdown.scss';

const cssContext = classnames.bind(css);

const EventsDropdown = props => {
  const { dropdownActiveItem, items, leagueSlug, onClick } = props;
  const [show, setShow] = useState(false);
  const [activeItem, setActiveItem] = useState(dropdownActiveItem);

  const clickEvent = e => {
    onClick(e);
  };

  const handleItemClick = item => {
    logEvent('events_dropdown', { type: 'item_click', item: item.name });

    setShow(false);
    setActiveItem(item.name);
  };

  const handleClick = () => {
    logEvent('events_dropdown', { type: 'open', active_item: activeItem });

    setShow(!show);
  };

  useEffect(
    () => {
      setActiveItem(dropdownActiveItem);
    },
    [dropdownActiveItem]
  );

  return (
    <div className={css.dropdown}>
      <div className={css.dropdownButton} onClick={handleClick} role="button" tabIndex={0}>
        <span className={css.activeItem}>{activeItem}</span>
        <span className={`${css.chevron} ${css.bottom}`} />
      </div>
      <ul className={cssContext(css.dropdownList, { hidden: !show })}>
        {items.map(item => {
          const route = item.route || `/${leagueSlug}/events/conference/${item.name}`;
          if (item.divider) {
            return (
              <li key={item.name} className={`col-xs-12 ${css.dropdownDivider}`}>
                {item.name}
              </li>
            );
          }
          return (
            <li className={`col-xs-6 col-sm-3 col-md-2 ${css.dropdownItem}`} key={item.name}>
              <Link
                onClick={e => {
                  e.stopPropagation();
                  handleItemClick(item);
                  clickEvent(item.name);
                }}
                route={route}
              >
                <div>{item.name}</div>
              </Link>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

EventsDropdown.propTypes = {
  dropdownActiveItem: PropTypes.string,
  leagueSlug: PropTypes.string,
  onClick: PropTypes.func,
  activeItem: PropTypes.string,
  schedule: PropTypes.object,
  params: PropTypes.object,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      divider: PropTypes.bool,
      route: PropTypes.string,
    })
  ).isRequired,
};

EventsDropdown.defaultProps = {
  dropdownActiveItem: '',
  leagueSlug: '',
  onClick: () => {},
  activeItem: '',
  schedule: { current_season: [], current_group: {} },
  params: {},
};

EventsDropdown.displayName = 'EventsDropdown';

const mapStateToProps = state => ({
  schedule: state.pageData.schedule,
  params: state.pageData.routeParams,
});

export default connect(mapStateToProps)(StyledComponent(EventsDropdown, [css]));
